module.exports = __webpack_public_path__ + "img/advice-c.d825e321.png";